import { useRef, useEffect } from 'react';
import useResizeObserver from '@hooks/useResizeObserver';

export default function useStickyOffset() {
  const nav = useRef();

  useEffect(() => {
    nav.current = document.querySelector('#header');
  }, []);

  const { height } = useResizeObserver(nav, { checkWidth: false });

  return Math.floor(height || 79);
}
